<template>
  <v-dialog v-model="staffPasswordDialog" persistent max-width="500px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-id-card-alt</v-icon>
              <span class="px-3">{{ $t('Change Staff Member Password') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-flex xs12 class="pb-3">
            <div class="caption no-select">{{ $t('Staff Member') }}</div>
            <strong>{{ staffMemberFullName || '-' }}</strong>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              v-model="form.newPassword"
              :label="`${$t('New Password')} *`"
              name="new_password"
              box
              hide-details
              background-color="white"
              class="mt-3 mb-2"
              autocomplete="off"
              ref="new_password"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              @click:append="showPassword = !showPassword"
              :error="errors.has('new_password')"
              v-validate="'required|min:4'"
              data-vv-delay="1000"
            />
          </v-flex>

          <v-flex xs12>
            <v-text-field
              v-model="form.newPasswordConfirmation"
              :label="`${$t('Confirm Password')} *`"
              name="new_password_confirmation"
              box
              hide-details
              background-color="white"
              class="mt-3 mb-2"
              autocomplete="off"
              :type="showPassword ? 'text' : 'password'"
              :error="errors.has('new_password_confirmation')"
              v-validate="'required|confirmed:new_password'"
              data-vv-delay="1000"
            />
          </v-flex>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >
            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnSaveLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Change Password') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'change-staff-password',

  props: {
    staffPasswordDialog: { type: Boolean, required: true },
    staffMemberId: { type: Number, required: true },
    staffMemberFullName: { type: String, required: true }
  },

  data() {
    return {
      btnSaveLoading: false,
      form: {
        newPassword: null,
        newPasswordConfirmation: null
      },
      showPassword: false
    }
  },

  watch: {
    staffPasswordDialog: {
      immediate: false,
      handler() {
        if (this.staffPasswordDialog) {
          this.addEscKeyListener()
          this.$validator.pause()
          for (let key in this.form) {
            this.form[`${key}`] = null
          }
          setTimeout(() => {
            this.$validator.resume()
          }, 2000)
        }
      }
    }
  },

  methods: {
    ...mapActions({
      changeStaffMemberPassword: 'staff/changeStaffMemberPassword'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.staffPasswordDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnSaveLoading = true

          let formData = new FormData(event.target)

          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          let payload = { id: this.staffMemberId, formData }

          this.changeStaffMemberPassword(payload)
            .then(() => {
              this.btnSaveLoading = false
              this.$emit('hidemodal')
            })
            .catch(() => {
              this.btnSaveLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
